<template>
  <b-container fluid>
    <b-row>
      <b-col cols="12">
        <div class="adapter-wrap">
          <div class="adapter-head">
            <p class="adapter-head-pn">P/N</p>
            <p class="adapter-head-pic">PIC</p>
            <div v-if="getInfoLength > 0">
              <p class="adapter-head-desc">DESC.</p>
              <p class="adapter-head-dim">DIM.</p>
            </div>
            <div v-if="getInfoLength > 1">
              <p class="adapter-head-desc">DESC.</p>
              <p class="adapter-head-dim">DIM.</p>
            </div>
            <div v-if="getInfoLength > 2">
              <p class="adapter-head-desc">DESC.</p>
              <p class="adapter-head-dim">DIM.</p>
            </div>
          </div>
          <div class="adapter-body">
            <div class="owl-carousel owl-theme">
              <div
                class="adapter-item items"
                v-for="(item, index) in adapters"
                :key="index"
              >
                <p class="adapter-item-title">{{ item.name.toUpperCase() }}</p>
                <div class="adapter-item-img-wrap">
                  <b-img class="adapter-item-img" :src="item.src" fluid></b-img>
                </div>
                <div v-for="(info, index) in item.info" :key="index">
                  <div class="adapter-item-desc">
                    <p>{{ info.desc.toUpperCase() }}</p>
                  </div>
                  <div class="adapter-item-dim">
                    <p v-for="(dim, index) in info.dim" :key="index">
                      {{ dim }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  props: ["adapters", "lg"],
  watch: {
    adapters: {
      handler() {
        this.owl();
      },
      immediate: true,
    },
  },
  computed: {
    getInfoLength() {
      return Math.max.apply(
        null,
        this.adapters.map((v) => v.info.length)
      );
    },
    getLg() {
      return this.lg ? this.lg : 5;
    },
  },
  methods: {
    owl() {
      $(".owl-carousel").trigger("destroy.owl.carousel");
      this.$nextTick(function () {
        $(".owl-carousel").owlCarousel({
          margin: 10,
          nav: true,
          navText: ["prev", "next"],
          responsive: {
            0: { items: 2 },
            600: { items: 3 },
            1000: { items: this.getLg },
          },
        });
      });
    },
  },
};
</script>

<style lang="scss">
.adapter-wrap {
  overflow: hidden;
}
.adapter-head {
  display: inline-block;
  width: 55px;
  vertical-align: top;
  box-shadow: 0px -2px 5px 0px rgba(217, 217, 217, 1);

  p {
    margin-bottom: 0;
    color: #333;
    font-size: 16px;
    font-weight: bold;
  }
  &-pic {
    line-height: 8.3;
  }
  &-desc {
    min-height: 30px;
  }

  &-dim {
    height: 50px;
    color: rgba(136, 136, 136, 1) !important;
  }
}
.adapter-body {
  display: inline-block;
  width: calc(100% - 55px);
}

.adapter-item {
  text-align: center;
  p {
    margin-bottom: 0;
  }
  &-title {
    font-size: 18px;
    color: $color-main;
  }
  &-img-wrap {
    padding: 0 15px;
    height: 130px;
  }
  &-img {
    margin: 0 auto;
    max-width: 120px !important;
  }
  &-desc {
    min-height: 30px;
    font-weight: bold;
  }
  &-dim {
    height: 50px;
    color: rgba(136, 136, 136, 1) !important;
  }
}
@media (min-width: 992px) {
  .adapter-body {
    width: calc(100% - 55px);
  }
}
</style>